import { Provider } from '@angular/core';
import { PERSISTED_SLICES, PersistedSlice } from '../../oidc/store/persisted-state';
import * as campusIdFeature from './campus-id.reducer';

export const provideCampusIdPersistence = (): Provider => ({
  provide: PERSISTED_SLICES,
  multi: true,
  useValue: {
    name: campusIdFeature.name,
    reshape: (stored: unknown): campusIdFeature.CampusIdState => {
      if(stored === null) {
        return campusIdFeature.initialState;
      }
      return stored as campusIdFeature.CampusIdState;
    },
  } satisfies PersistedSlice<campusIdFeature.CampusIdState>,
});
